import { Button, Flex, Form, Input } from "antd";
import FormSection from "../../../components/FormSection";
import { numberValidation } from "../../../utils/ValidationRules";

const LimitLock = () => {
  const form = Form.useFormInstance();
  const isExclusive = Form.useWatch("is_exclusive", form) ?? true;

  return (
    <FormSection
      title="Limit & Lock"
      description="Control how often it's used and keep it exclusive if you like."
      withoutCard
      dividerEnd
    >
      <>
        <Form.Item name="is_exclusive" hidden initialValue={true}>
          <Input type="hidden" />
        </Form.Item>
        <Form.Item
          label="Usage Limit"
          name={"usage_limit"}
          rules={numberValidation("Usage Limit", "", false, true)}
        >
          <Input placeholder="Leave empty for unlimited" />
        </Form.Item>
        <Flex gap={20}>
          <Button
            type={!isExclusive ? "default" : "text"}
            onClick={() => form.setFieldValue("is_exclusive", false)}
            className={`${isExclusive ? "" : "!border !border-black"}`}
          >
            Public
          </Button>
          <Button
            type={isExclusive ? "default" : "text"}
            onClick={() => form.setFieldValue("is_exclusive", true)}
            className={`${!isExclusive ? "" : "!border !border-black"}`}
          >
            Private
          </Button>
        </Flex>
      </>
    </FormSection>
  );
};

export default LimitLock;
